import type { IPromptBoxOptions } from "../models";
import type { IKendoJQuery } from "../../core";

export interface IAccessibilityManagerContext {
    wrapper: IKendoJQuery;
    getOptions: () => IPromptBoxOptions;
    getInputElement: () => JQuery | null;
}

export class AccessibilityManager {
    private context: IAccessibilityManagerContext;

    constructor(context: IAccessibilityManagerContext) {
        this.context = context;
    }

    applyInitial(): void {
        const options = this.context.getOptions();
        const input = this.context.getInputElement();
        input.attr("aria-label", options.messages?.messageBoxTitle || "Message");

        if (!options.enable) {
            this.context.wrapper.attr("aria-disabled", "true");
        }

        if (options.readonly) {
            this.updateInputAccessibility();
        }

        if (options.loading) {
            this.context.wrapper.attr("aria-busy", "true");
        }
    }

    updateInputAccessibility(): void {
        const options = this.context.getOptions();
        const input = this.context.getInputElement();

        if (!input) {
            return;
        }

        input.attr("aria-label", options.messages?.messageBoxTitle || "Message");

        if (options.readonly) {
            input.attr("aria-readonly", "true");
        } else {
            input.removeAttr("aria-readonly");
        }

        if (!options.enable) {
            input.attr("aria-disabled", "true");
        } else {
            input.removeAttr("aria-disabled");
        }
    }

    updateWrapper(state: { disabled?: boolean; loading?: boolean }): void {
        if (state.disabled !== undefined) {
            if (state.disabled) {
                this.context.wrapper.attr("aria-disabled", "true");
            } else {
                this.context.wrapper.removeAttr("aria-disabled");
            }
        }

        if (state.loading !== undefined) {
            if (state.loading) {
                this.context.wrapper.attr("aria-busy", "true");
            } else {
                this.context.wrapper.removeAttr("aria-busy");
            }
        }
    }
}
